import { useEffect, useState } from 'react'
import { useRecordKalamaTeaserSeen } from 'src/modules/brand/hooks'
import { isKalamaTeaserActive } from 'src/modules/brand/utils/kalama-branding'
import { KALAMA_NOTICE_PATHS } from 'src/modules/brand/utils/kalama-notice'
import { KalamaNoticeBannerContent } from '../kalama-notice-banner-content'
import {
  dismissKalamaTeaser,
  isKalamaTeaserDismissed,
  isKalamaTeaserImpressionRecorded,
  markKalamaTeaserImpressionRecorded,
} from './kalama-teaser-banner.domain'
import type { KalamaTeaserBannerProps } from './kalama-teaser-banner.interface'

export function KalamaTeaserBanner({ path, profile }: KalamaTeaserBannerProps) {
  const accountId = profile?.id
  const [isDismissed, setIsDismissed] = useState(() => readDismissed(accountId))
  const recordKalamaTeaserSeen = useRecordKalamaTeaserSeen()
  const isVisible = Boolean(accountId) && !isDismissed && isKalamaTeaserActive() && KALAMA_NOTICE_PATHS.includes(path)

  useEffect(() => {
    setIsDismissed(readDismissed(accountId))
  }, [accountId])

  // `isDismissed` lags one render behind a new `accountId`, so storage is re-read before posting.
  useEffect(() => {
    if (!isVisible || readDismissed(accountId) || isKalamaTeaserImpressionRecorded(accountId)) return
    recordKalamaTeaserSeen('web_banner', { onSuccess: () => markKalamaTeaserImpressionRecorded(accountId) })
  }, [isVisible, accountId, recordKalamaTeaserSeen])

  if (!isVisible) return null

  const handleDismiss = () => {
    setIsDismissed(true)
    dismissKalamaTeaser(accountId)
  }

  return (
    <KalamaNoticeBannerContent
      messageId="brand.kalamaTeaser.message"
      linkId="brand.kalamaTeaser.link"
      dismissId="brand.kalamaTeaser.dismiss"
      testId="kalama-teaser-banner"
      onDismiss={handleDismiss}
    />
  )
}

function readDismissed(accountId?: string): boolean {
  return Boolean(accountId) && isKalamaTeaserDismissed(accountId)
}
